export const specContainer = "s1n1qojj";
export const title = "t181ladw";
export const downloads = "dkwhq91";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");